import React from 'react'
import { Provider } from 'react-redux'
import { createStore, compose } from 'redux'
import Reducers from './_reducers'

export default ({ element }) => {
  const store = createStore(
    Reducers,
    compose(
      process.env.NODE_ENV === 'development' && window.devToolsExtension
        ? window.devToolsExtension()
        : f => f
    )
  )
  return <Provider store={store}>{element}</Provider>
}
